<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="signup">
                            <ion-card-header v-if="!processingSignup">
                                <ion-card-title text-left color="primary">{{ $t('screens.location.where-from') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content v-if="!processingSignup">
                                <transition-group name="collapse-fade">
                                    <ion-label text-left v-if="!nearbyAirports.length && !gettingLocation" key="suggest">{{ $t('screens.location.find-explanation') }}</ion-label>
                                    <ion-label text-center v-show="!nearbyAirports.length && gettingLocation" key="processing">
                                        <LocationCompass></LocationCompass>
                                    </ion-label>
                                    <ion-label text-left v-if="nearbyAirports.length" key="obtained">{{ $t('screens.location.closest') }}</ion-label>
                                </transition-group>
                                <transition-group name="collapse-fade">
                                    <ion-card v-for="airport in nearbyAirports" v-bind:key="airport.id" class="airport-list" @click="signUp(airport.id)">
                                        <ion-item lines="none"><ion-icon name="airplane" size="small"></ion-icon><ion-label>{{airport[airportNameProperty] || airport.name}}, {{airport.country_id}}</ion-label><ion-label text-right>{{airport.dist}} {{units}}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                                    </ion-card>
                                </transition-group>
                                <ion-button size="default" @click="getLocation"><ion-icon name="compass"></ion-icon>{{locateButtonText}}</ion-button>
                                <div class="divider">{{ $t('screens.location.or') }}</div>
                                <ion-button size="default" color="medium" class="choose" @click="$router.push('/location-region')">{{ $t('screens.location.choose-list') }}</ion-button>
                            </ion-card-content>
                            <ion-card-content v-else>
                                <Loading :msg="$t('screens.location.give-us-processing')"></Loading>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import helpers from '@/helpers';
import LocationCompass from '@/components/LocationCompass.vue';
import Loading from '@/components/Loading.vue';
import axios from "axios";

export default {
    name: 'location',
    components: {
        LocationCompass,
        Loading
    },
    data() {
        return {
            unit_locale: 'm', //i impertial, m metric
            units: 'km',
            /*airports: [{
                id: 'BCN',
                lat: 41.302778,
                lon: 2.094444,
                name: 'Barcelona',
                country: 'ES'
            },{
                id: 'GRO',
                lat: 41.909167,
                lon: 2.763333,
                name: 'Girona',
                country: 'ES'
            }],*/
            airports: [],
            nearbyAirports: [],
            airportNameProperty: 'name',
            gettingLocation: false,
            intervalID: false,
            processingSignup: false,
            fetchingAirports: false,
            savingScreen: false,
            timeout: 10000
        }
    },
    methods: {
        signUp: function(cityId) {
            let pwd;

            do {
                pwd = helpers.generateRandomPassword();
            } while( !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!\-_.:;?[\]{}()/&%$#@=\\*+])[A-Za-z\d!\-_.:;?[\]{}()/&%$#@=\\*+]{8,}$/.test(pwd) );

            this.processingSignup = true;

            // if the user is already signedin from federation, we take a different path
            if(this.$store.state.signedIn) {
                axios.put(process.env.VUE_APP_API_FEED_BASE + '/profile',
                    {
                        "fromCityId": cityId
                    },
                    {
                        headers: {Authorization: `Bearer ${this.$store.state.user.signInUserSession.getIdToken().getJwtToken()}`},
                    }
                ).then(response => {
                    this.$logger.debug(response);
                    //this.processingSignup = false;
                    this.$router.push('/');
                }).catch((err) => {
                    this.$logger.error(err);
                });
            } else {
                this.$Amplify.Auth.signUp({
                    username: this.$store.state.signUp.email,
                    password: pwd,
                    attributes: {
                        email: this.$store.state.signUp.email,
                        'custom:fromCityId': cityId
                    },
                    clientMetadata: {
                        locale: this.$i18n.locale
                    }
                }).then(data => {
                    pwd = '';
                    this.$logger.debug(data);
                    //this.processingSignup = false;

                    this.$AmplifyEventBus.$emit('authState', 'confirmSignUp');
                    this.$router.push({name: 'signup-success', params: {user: data.userSub}});
                }).catch(err => {
                    pwd = '';
                    this.$logger.error(err);
                    this.processingSignup = false;
                });
            }
        },
        getLocation: function () {
            if ('geolocation' in navigator) {
                this.gettingLocation = true;
                this.nearbyA = [];
                const t1 = new Date().getTime();

                navigator.geolocation.getCurrentPosition(pos => {
                    const t2 = new Date().getTime();
                    this.$logger.debug('time to get location', t2-t1);
                    // delay showing results at least 2 seconds to avoid weird glitches
                    setTimeout(() => {
                        this.gettingLocation = false;
                        const coords = pos.coords;
                        // eslint-disable-next-line no-unused-vars
                        for (const airport of this.airports) {
                            airport.dist = this.calculateDistance(coords.latitude, coords.longitude, airport.lat, airport.lon);
                            //this.$logger.debug(airport.name, airport.dist, this.units);
                        }
                        const sorted = this.airports.sort(this.compareDistance);
                        // show 2 if distance of 3rd is more than 1000
                        this.nearbyAirports = sorted.slice(0, sorted[2].dist > 1000 ? 2 : 3);
                    }, t2 - t1 > 2000 ? 0 : 2000 - (t2 - t1));
                }, err => {
                    this.gettingLocation = false;
                    if ('code' in err && err.code === 1) {
                        return this.$ionic.alertController.create({
                                header: this.$t('screens.location.denied'),
                                message: this.$t('screens.location.denied-message'),
                                buttons: [this.$t('screens.location.button-ok')],
                        }).then(a => a.present())
                    }
                });
            } else {
                //TODO: location functionality not supported
            }
        },
        compareDistance: function(a, b) {
            if (a.dist > b.dist) {
                return 1;
            } else if (a.dist < b.dist) {
                return -1;
            }
            return 0;
        },
        calculateDistance: function(lat1, lon1, lat2, lon2) {
            const R = 6371;
            const km2miCoef = 0.62137119224;
            const dLat = (lat2-lat1) * Math.PI / 180;
            const dLon = (lon2-lon1) * Math.PI / 180;
            const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            let d = R * c;
            if (this.unit_locale == 'i') {
                d = d * km2miCoef;
            }
            if (d > 1) {
                this.units = this.unit_locale == 'i' ? 'mi' : 'Km';
                return Math.round(d);
            } else {
                if (this.unit_locale == 'i') {
                    this.units = 'mi';
                    return Math.round(d * 10) / 10;
                } else {
                    this.units = 'm';
                    return Math.round(d * 1000);
                }
            }
        },
        getFromData: async function() {
            this.fetchingAirports = true;
            axios.get(process.env.VUE_APP_STATIC_ASSETS_URL + '/app/from_data.json').then(response => {
                if (response.data.airports) {
                    this.airports = response.data.airports;
                    localStorage.setObject('from_airports', response.data.airports);
                }
                if (response.data.regions) {
                    localStorage.setObject('from_regions', response.data.regions);
                }
                this.fetchingAirports = false;
            }).catch((error) => {
                this.$logger.error(error);
                if (error.response.data && error.response.data.code == 420 ) {
                    // no alerts setup
                    this.noAlerts = true;
                }
            });
        }
    },
    mounted() {
        if (this.$i18n.locale != 'en-us') {
            this.airportNameProperty = 'name_' + this.$i18n.locale;
        }
        this.getFromData();
        const userLang = helpers.detectLanguage();
        this.$logger.debug("The language is: " + userLang);
    },
    computed: {
        locateButtonText: function() {
            if (this.gettingLocation) {
                return this.$t('screens.location.finding');
            } else {
                if (this.nearbyAirports.length) {
                    return this.$t('screens.location.check-again');
                } else {
                    return this.$t('screens.location.find-nearby');
                }
            }
        }
    },
    beforeCreate() {
        if (!this.$store.state.signedIn && !this.$store.state.signUp.email) {
            this.$router.push('/signup')
        }
    },
    beforeDestroy() {
        //the watcher gets destroyed too fast so we need to dismiss the loading here just in case
        if (this.savingScreen) {
            this.savingScreen.dismiss();
        }
    },
    watch: {
        processingSignup: function(val) {
            if (val) {
                this.$ionic.loadingController.create({
                    message: this.$t('screens.location.saving'),
                    duration: this.timeout,
                }).then(l => {
                    this.savingScreen = l;
                    l.present();
                    l.onDidDismiss().then(() => {
                        this.savingScreen = false;
                    });
                });
            } else {
                this.savingScreen.dismiss();
            }
        }
    }
}
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg7.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-item {
        --background: rgba(255,255,255,.6);
        margin-left: 1%;
        margin-bottom: .5em;
    }

    ion-button {
        margin-top: 1em;
    }

    ion-button.choose {
        margin-top: 0;
    }

    ion-label {
        font-family: 'Nunito', sans-serif;
        color: #fff;
        padding: .25em 0;
        display: block;
    }

    ion-card-header {
        --background: none;
    }

    ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-card-title {
        --color: #333;
        font-size: 2.5em;
        font-weight: bold;
    }

    ion-col {
        padding: 0;
    }

    .content-row ion-label {
        color: #333;
        font-size: 1.2em;
    }

    ion-button ion-icon {
        margin-right: .5em;
    }

    ion-item ion-icon {
        margin-right: .25em;
    }

    .airport-list ion-item {
        --inner-padding-end: 0em;
        margin: 0;
        cursor: pointer;
    }

    .airport-list:hover {
        background-color: #ffccdd;
    }

    .airport-list ion-label {
        font-size: .9em;
    }

    .airport-list ion-label:nth-child(3) {
        color: #666;
    }

    .airport-list .arrow {
        margin-left: .5em;
    }
</style>